<script lang="ts">
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { SbImage } from '../types';
	import Image from '../components/image.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			items: Array<ISbStoryData<{ icon: SbImage; text: string }>['content']>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid16 margin>
	<ul
		use:editable={content}
		class="col-span-full flex flex-wrap items-center justify-center gap-x-5 gap-y-12 lg:col-start-2 lg:col-end-[16] lg:justify-between lg:px-6"
	>
		{#each content.items as { icon, text }}
			<li class="flex flex-col items-center gap-y-3 text-brown-1 max-lg:basis-[calc(50%-10px)]">
				<Image
					class="h-6 w-6 lg:h-8 lg:w-8"
					width={32}
					height={32}
					src={icon.filename}
					alt={icon.alt}
					title={icon.title}
				/>
				<span
					class="text-center tracking-[-.16px] text-[16px/150%] lg:text-[20px]/[140%] lg:tracking-[.2px]"
					>{text}</span
				>
			</li>
		{/each}
	</ul>
</PageGrid16>
